export const queryKeys = {
  user: ['user'] as const,
  areaReports: ['area-reports'] as const,
  areaReport: (id: string, lang?: string) => ['area-report', id, lang] as const,
  areaGroups: ['area-groups'] as const,
  areaGroup: (id: string) => ['area-group', id] as const,
  aiSummary: (hash: string, lang: string) =>
    ['ai-summary', hash, lang] as const,
  areaPortfolios: ['area-portfolios'] as const,
  closebyAreas: ['closeby-areas'] as const,
  portfolios: ['portfolios'] as const,
  portfolio: (id: string, year?: string, lang?: string) =>
    ['portfolio', id, year, lang] as const,
  portfolioAiSummary: (hash: string, lang: string) =>
    ['portfolio-ai-summary', hash, lang] as const,
  policeEventTrace: (id: string) => ['police-event-trace', id] as const,
  properties: ['properties'] as const,
  property: (id: string, year?: string, lang?: string, portfolioId?: string) =>
    ['property', id, year, lang, portfolioId] as const,
  propertyAiSummary: (hash: string, lang: string) =>
    ['property-ai-summary', hash, lang] as const,
  propertyAreaReport: (propertyId: string) =>
    ['property-area-report', propertyId] as const,
  organization: ['organization'] as const,
  adminOrganizations: ['admin-organizations'] as const,
  adminOrganization: (id: string) => ['admin-organization', id] as const,
  userStats: ['user-stats'] as const,
  adminPlans: ['admin-plans'] as const,
} as const;
